import AmanakiJobs from "@components/About/Careers/AmanakiJobs";
import FeaturedImage from "@components/About/Careers/FeaturedImage";
import Humans from "@components/About/Careers/Humans";
import PeopleAndCulture from "@components/About/Careers/PeopleAndCulture";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const banner = helper.formatBanner(pageData);
  return (
    <div className="" data-scroll-container>
      <Header />
      <Banner image={_.get(banner, "image")} title={_.get(banner, "title")} />
      <Breadcrumbs data={router.breadcrumbs("about-careers", {})} />
      <PeopleAndCulture />
      <FeaturedImage />
      <Humans />
      <AmanakiJobs />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
